import { CircularProgress } from '@mui/material';
import React from 'react';

export default function DataItem({
  label,
  value,
  isLoader
}) {
  return (
    <div className='cursor-pointer group rounded-[20px] w-full bg-primary border-2 border-primary flex items-center justify-between px-5 py-2 hover:bg-white'>
      <p className='text-2xl text-white font-semiBold text-xl w-[230px] group-hover:text-primary'>{label}</p>
      <p className='bg-white text-primary font-semiBold text-xl w-24 text-center rounded-full group-hover:bg-primary group-hover:text-white'>
        {isLoader
        ? <CircularProgress sx={{color: '#A31732'}} size={15} thickness={5}/>
        : value
        }
      </p>
    </div>
  );
}
